function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var getStyles = function getStyles(prefixCls, token) {
  return _defineProperty({}, ".".concat(prefixCls), {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '.section-title': {
      color: 'rgba(0, 0, 0, 0.85)',
      fontSize: 16,
      fontWeight: 500,
      lineHeight: '24px',
      backgroundColor: '#F6F6F9',
      padding: '12px 0 12px 12px',
      marginBottom: 16
    },
    '.item': {
      display: 'flex',
      padding: '12px 8px',
      alignItems: 'flex-start',
      gap: '8px',
      background: '#f6f6f9',
      cursor: 'pointer',
      '.icon': {
        flexShrink: 0
      },
      '.content': {
        flex: 1,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        gap: 6.5
      },
      '.title': {
        color: '#3d414d',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      },
      '.help': {
        color: '#3d414d',
        fontSize: 12,
        lineHeight: 1,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      },
      '.helpLight': {
        color: '#9ea0a6',
        fontSize: 12,
        lineHeight: 1
      }
    }
  });
};